import React from 'react';
import i18n from '../../../i18n';
import { useSelector } from 'react-redux';
import { CircularProgress, Hidden } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { authStoreCategorySelector } from 'state/auth/selectors';
import { onboardingStoreFormDataSelector } from 'state/onboarding/selectors';

import { Icon } from 'components/Icon/Icon';
import { Text, TextTypography } from 'components/Text/Text';

import { ReactComponent as CatalogIcon } from 'assets/glyphs/catalog.svg';

const useStyles = makeStyles(theme => ({
    container: {
        display: 'flex',
        flexGrow: 1,
        flexDirection: 'column',
        height: '100%',
    },
    spacer: {
        flex: 1,
    },
    content: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        [theme.breakpoints.up('sm')]: {
            height: '100%',
            flexGrow: 1,
            paddingBottom: 100,
        },
    },
    title: {
        margin: '0 auto',
        marginTop: theme.spacing(3.5),
        marginBottom: theme.spacing(3),
        textAlign: 'center',
        minHeight: 320,
    },
}));

export const CatalogEmpty = () => {
    const classes = useStyles();
    const { t } = i18n.useTranslation();

    const storeFormData = useSelector(onboardingStoreFormDataSelector);
    const authStoreCategory = useSelector(authStoreCategorySelector);
    const storeCategory = authStoreCategory ?? storeFormData?.storeCategory;

    return (
        <div className={classes.container}>
            <Hidden smUp>
                <div className={classes.spacer} />
            </Hidden>
            <div className={classes.content}>
                <Icon component={CatalogIcon} size={64} svgSize={64} />
                <div className={classes.title}>
                    {storeCategory ? (
                        <Text typography={TextTypography.DISPLAY_STRONG}>
                            {t(`onboarding:emptyCatalog.storeCategory.${storeCategory}`)}
                        </Text>
                    ) : (
                        <CircularProgress />
                    )}
                </div>
            </div>
        </div>
    );
};
